// extracted by mini-css-extract-plugin
module.exports = {"footer_logo":"FooterLogo_footer_logo_3y9L-"};